export default {
  buttons: {
    update_meal: 'Menü aktualisieren',
  },
  error_messages: {
    missing_fields: 'Bitte wähle alle erforderlichen Felder aus',
    product_unavailable: 'Ausverkauft!',
  },
};
